import Model from './Model'

export default class ReportComment extends Model {
  resource() {
    return 'reports/comment'
  }
}
